import { ForwardRefExoticComponent } from 'react';

import WrapperMockComponent from '@hh.ru/magritte-ui-icon/WrapperMockComponent';
import { mockComponent } from '@hh.ru/magritte-ui-mock-component';

export { type IconColor, type IconDisabledColor } from '@hh.ru/magritte-ui-icon/types';

export const IconDynamic: ForwardRefExoticComponent<Record<string, unknown>> = mockComponent('IconDynamic', undefined, {
    withChildren: true,
});
export const ATSize16 = mockComponent(
    'ATSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ATSize24 = mockComponent(
    'ATSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ATSize32 = mockComponent(
    'ATSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AUSize16 = mockComponent(
    'AUSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AUSize24 = mockComponent(
    'AUSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AUSize32 = mockComponent(
    'AUSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AZSize16 = mockComponent(
    'AZSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AZSize24 = mockComponent(
    'AZSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AZSize32 = mockComponent(
    'AZSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BYSize16 = mockComponent(
    'BYSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BYSize24 = mockComponent(
    'BYSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BYSize32 = mockComponent(
    'BYSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ENSize16 = mockComponent(
    'ENSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ENSize24 = mockComponent(
    'ENSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ENSize32 = mockComponent(
    'ENSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GESize16 = mockComponent(
    'GESize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GESize24 = mockComponent(
    'GESize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GESize32 = mockComponent(
    'GESize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KGSize16 = mockComponent(
    'KGSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KGSize24 = mockComponent(
    'KGSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KGSize32 = mockComponent(
    'KGSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KZSize16 = mockComponent(
    'KZSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KZSize24 = mockComponent(
    'KZSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KZSize32 = mockComponent(
    'KZSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RUSize16 = mockComponent(
    'RUSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RUSize24 = mockComponent(
    'RUSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RUSize32 = mockComponent(
    'RUSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UZSize16 = mockComponent(
    'UZSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UZSize24 = mockComponent(
    'UZSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UZSize32 = mockComponent(
    'UZSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);
